import React, { useState } from "react";
import { useListTickets } from "@workspace/api-client-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge } from "@/components/StatusBadge";
import { TablePagination } from "@/components/TablePagination";

const PAGE_SIZE = 10;

export function TicketsList() {
  const [page, setPage] = useState(1);
  const { data, isLoading, error } = useListTickets({ page, pageSize: PAGE_SIZE });

  if (isLoading) return <div className="p-6 animate-pulse"><div className="h-8 bg-gray-200 w-1/4 rounded mb-6"></div><div className="h-64 bg-gray-200 rounded"></div></div>;
  if (error || !data) return <div className="p-6 text-red-500">Failed to load tickets.</div>;

  const tickets = data.items;

  return (
    <Card className="border-0 shadow-sm">
      <CardHeader>
        <CardTitle className="text-lg text-[#0B132B]">Tickets</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <Table>
          <TableHeader className="bg-gray-50">
            <TableRow>
              <TableHead>Reference</TableHead>
              <TableHead>Subject</TableHead>
              <TableHead>Priority</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {tickets.map((ticket) => (
              <TableRow key={ticket.id}>
                <TableCell className="font-medium">{ticket.reference}</TableCell>
                <TableCell>{ticket.subject}</TableCell>
                <TableCell className="capitalize">{ticket.priority}</TableCell>
                <TableCell><StatusBadge status={ticket.status} /></TableCell>
              </TableRow>
            ))}
            {tickets.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} className="text-center p-8 text-gray-500">No tickets found.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          page={page}
          pageSize={PAGE_SIZE}
          total={data.total}
          onPageChange={setPage}
        />
      </CardContent>
    </Card>
  );
}
